import BootstrapSwitchButton from "bootstrap-switch-button-react";
import React, { useEffect, useState } from "react";

import { Container, Row, Col, Button, Modal, InputGroup, Form, FormControl, Card, Accordion } from 'react-bootstrap';
import Select from "react-dropdown-select";
import { FaCheckCircle, FaPlayCircle, FaPlusCircle, FaTimesCircle } from "react-icons/fa";
import { ChainJobRequest } from "../../../data/chainJob/chainJob.shemas";
import { CompanyMaster } from "../../../models/companymaster/CompanyMaster";
import { getLegacyIdConfig } from "../../../data/legacyConfig/legacyConfig.repository";
import { LegacyIdConfigResponse } from "../../../data/legacyConfig/legacyConfig.shemas";

type Props = {
    isOpen: boolean;
    onClose: (action: boolean) => void;
    onClickCreate: (body: ChainJobRequest) => void;
    companyMaster: CompanyMaster[];
}

interface LegacyRow {
    legacyId: string;
    legacyName: string;
}

export function ChainJobConfigAddModal(props: Props) {
    const { isOpen, onClose, companyMaster, onClickCreate } = props;

    const [rows, setRows] = useState<LegacyRow[]>([]);
    const [chainJobConfig, setChainJobConfig] = useState<ChainJobRequest>();
    const [legacyIdConfig, setLegacyIdConfig] = useState<LegacyIdConfigResponse[]>()

    const handleChangeConfig = (key: keyof ChainJobRequest, value: ChainJobRequest[keyof ChainJobRequest]) => {
        setChainJobConfig(prevState => {
            return {
                ...prevState,
                [key]: value
            };
        });
    }

    useEffect(() => {
        fetchLegacyConfig();
    }, [chainJobConfig?.CompanyCode])


    const handleAddRow = () => {
        setRows([...rows, { legacyId: '', legacyName: '' }]);
    };

    const handleRemoveRow = (index: number) => {
        const newRows = rows.filter((_, i) => i !== index);
        setRows(newRows);
    };

    const handleInputChange = (
        e: string,
        index: number,
    ) => {
        const [legacyId, legacyName] = e.split("|");
        const newRows = [...rows];
        newRows[index]["legacyId"] = legacyId;
        newRows[index]["legacyName"] = legacyName;
        const legacyList = newRows.map(item => `${item.legacyId},${item.legacyName}`).join('|');

        handleChangeConfig('LegacyList', legacyList)
        setRows(newRows);
    };

    const fetchLegacyConfig = async () => {
        const response = await getLegacyIdConfig({ sid: '555', company_code: chainJobConfig?.CompanyCode! });

        if (response) {
            setLegacyIdConfig(response.result_list);
        }
    }

    const onClickCreateChainJob = async () => {
        await onClickCreate(chainJobConfig!);
    }

    return (
        <Modal dialogClassName="custom-modal" show={isOpen} onHide={() => onClose(false)} backdrop="static" keyboard={false}>
            <Modal.Header translate="yes" closeButton>
                <Modal.Title>Add Job Config</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col>
                        <div className='trapezoid-head' style={{ width: '200px' }}>
                            <span>
                                Legacy
                            </span>
                        </div>
                    </Col>
                    <Col>
                        <Form.Check type="checkbox" style={{ padding: "10px 5px 5px 30px" }} id="checkImportantJob" label="ImportantJob" />
                    </Col>
                </Row>
                <div className="mat-box shadow-sm p-3 mb-3 bg-white rounded">
                    <Row>
                        <Col sm={6}>
                            <Form.Label className="font-weight-bold">Company Code :</Form.Label>
                            <InputGroup className="mb-3">
                                <FormControl
                                    as="select"
                                    id="companycode"
                                    aria-describedby="basic-addon3"
                                    onChange={(e) => {
                                        const [sid, companyCode] = e.target.value.split("|");
                                        handleChangeConfig("Sid", '555');
                                        handleChangeConfig("CompanyCode", companyCode);
                                    }}
                                >
                                    <option value={""}>{""}</option>
                                    {companyMaster && companyMaster.map((value, key) => (
                                        <option key={key} value={`${value.sid}|${value.company_code}`}>{value.company_name}</option>
                                    ))}
                                </FormControl>
                            </InputGroup>
                        </Col>
                        <Col sm={6}>
                            <Form.Label className="font-weight-bold">Chain Job ID :</Form.Label>
                            <InputGroup className="mb-3">
                                <FormControl
                                    id="chainjobid"
                                    aria-describedby="basic-addon3"
                                    onChange={(e) => { handleChangeConfig("ChainId", e.target.value) }}
                                />
                            </InputGroup>
                        </Col>
                        <Col sm={6}>
                            <Form.Label className="font-weight-bold">Chain Job Name :</Form.Label>
                            <InputGroup className="mb-3">
                                <FormControl
                                    id="chainjobname"
                                    aria-describedby="basic-addon3"
                                    onChange={(e) => { handleChangeConfig("ChainName", e.target.value) }}
                                />
                            </InputGroup>
                        </Col>
                        <Col sm={6}>
                            <Form.Label className="font-weight-bold">Is Active :</Form.Label>
                            <InputGroup className="mb-3 mt-1">
                                <BootstrapSwitchButton
                                    checked={chainJobConfig?.IsActive === 'true' ? true : false}
                                    onlabel='Y'
                                    offlabel='N'
                                    size="sm"
                                    onstyle="info"
                                    offstyle="dark"
                                    width={80}
                                    onChange={(e) => {
                                        handleChangeConfig("IsActive", e ? "ture" : "false")
                                    }}
                                />
                            </InputGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <Row>
                                <Col>
                                    <Form.Label className="font-weight-bold">
                                        Cron trigger List :
                                    </Form.Label>
                                    <div className="d-flex mb-3">
                                        <Button className="text-nowrap" variant="outline-secondary" id="button-addon2" size="sm">
                                            <FaPlusCircle />
                                            &nbsp;Add Crontriger
                                        </Button>
                                        <Card className="w-100">
                                            <Card.Body className="list_card">
                                                <Row>
                                                    <Col lg={3}>
                                                        value in mapping
                                                    </Col>
                                                </Row>
                                            </Card.Body>
                                        </Card>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
                <div>
                    {rows.map((row, index) => (
                        <Row key={index} className="align-items-center">
                            <Col sm={0.5} className="text-left ml-3">
                                <Button variant="danger" size="sm" onClick={() => handleRemoveRow(index)}>
                                    <FaTimesCircle />
                                </Button>
                            </Col>
                            <Col sm={5}>
                                <Form.Label className="font-weight-bold">Legacy ID :</Form.Label>
                                <InputGroup className="mb-3">
                                    <FormControl
                                        as="select"
                                        value={`${row.legacyId}|${row.legacyName}`}
                                        onChange={(e) => handleInputChange(e.target.value, index)}
                                        aria-describedby="basic-addon3"
                                    >
                                        {legacyIdConfig && legacyIdConfig.map((value, index) => (
                                            <option key={index} value={`${value.legacyid}|${value.legacyname}`}>{value.legacyid}: {value.legacyname}</option>
                                        ))}
                                    </FormControl>
                                </InputGroup>
                            </Col>
                            <Col sm={6}>
                                <Form.Label className="font-weight-bold">Legacy Name :</Form.Label>
                                <InputGroup className="mb-3">
                                    <FormControl
                                        value={row.legacyName}
                                        // onChange={(e) => handleInputChange(e.target.value, index, 'legacyName')}
                                        disabled
                                        aria-describedby="basic-addon3"
                                    />
                                </InputGroup>
                            </Col>
                        </Row>
                    ))}
                    <Button onClick={handleAddRow} variant="primary">Add Row</Button>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="danger" onClick={() => onClose(false)}>
                    <FaTimesCircle /> Close
                </Button>
                <Button variant="primary" onClick={onClickCreateChainJob}>
                    <FaCheckCircle /> Save
                </Button>
            </Modal.Footer>
        </Modal >
    );
}